export default {
  getConfigurations(state) {
    return state.configurations;
  }
};